(function () {
  function initGallery(root) {
    if (!root || root.dataset.bvGalleryInit === '1') return;
    root.dataset.bvGalleryInit = '1';

    const mainImg = root.querySelector('.bv-gallery__main');
    const thumbs = Array.from(root.querySelectorAll('.bv-gallery__thumb'));
    const dataEl = root.querySelector('.bv-gallery__data');

    if (!mainImg) return;

    let data = null;
    try {
      data = dataEl ? JSON.parse(dataEl.textContent) : null;
    } catch (e) {}

    function setActiveThumb(mediaId) {
      thumbs.forEach((btn) => {
        btn.classList.toggle('is-active', String(btn.dataset.mediaId) === String(mediaId));
      });
    }

    function setMainFromThumb(btn) {
      if (!btn) return;
      const src = btn.dataset.src;
      const srcset = btn.dataset.srcset;
      const alt = btn.dataset.alt || '';

      if (src) mainImg.src = src;
      if (srcset) mainImg.setAttribute('srcset', srcset);
      mainImg.alt = alt;
      mainImg.dataset.mediaId = btn.dataset.mediaId || '';
      setActiveThumb(btn.dataset.mediaId || '');
    }

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => setMainFromThumb(btn));
    });

    function findVariantIdInput() {
      return root.closest('product-info')?.querySelector('input[name="id"]')
        || document.querySelector('input[name="id"]');
    }

    function syncToVariant() {
      if (!data || !data.variants || !data.variants.length) return;

      const variantInput = findVariantIdInput();
      if (!variantInput) return;

      const variantId = Number(variantInput.value || 0);
      if (!variantId) return;

      const v = data.variants.find((x) => Number(x.id) === variantId);
      const mediaId = v ? Number(v.featured_media_id || 0) : 0;
      if (!mediaId) return;

      const btn = thumbs.find((b) => Number(b.dataset.mediaId) === mediaId);
      if (btn) setMainFromThumb(btn);
    }

    const variantInput = findVariantIdInput();
    if (variantInput) {
      variantInput.addEventListener('change', syncToVariant);

      const mo = new MutationObserver(syncToVariant);
      mo.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }

    syncToVariant();
  }

  function initAll() {
    document.querySelectorAll('.bv-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();